var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var _excluded = ["onArtworkClick"], _excluded2 = ["className"], _excluded3 = ["className"];
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component } from "react";
import classNames from "classnames";
import { Button, Picture, PicturePlaceholder, Link, Heading, TextPlaceholder, BasePlaceholder } from "@riseart/common";
import { isTouchDevice } from "@riseart/fe-utils";
import { Card, CardContent, CardMedia, CardFooter, CardOverlay } from "@riseart/card";
import { CommentIcon } from "@riseart/icons";
import { artCardCls, artCardTouchCls, artCardDisplayStyle1Cls, artCardDisplayStyle2Cls, artCardDisplayStyle3Cls, artCardDisplayStyle4Cls, artCardDisplayStyle5Cls, artCardDisplayStyle8Cls, artCardBorderCls, artCardBackgroundCls, artCardHeadingCls, artCardHeadingFlexCls, artCardPictureCls, artCardLinkCls, artCardLinkArtworkCls, artCardLinkArtistCls, artCardDetailCls, artCardAdditionalContentCls, artCardOverlayBtnCls, artCardFooterCls, artCardFooterLeftCls, artCardFooterRightCls, artCardMediaHoverCls, artCardOverImageCls, artCardOverImageSectionCls, artCardOverImageSectionRightCls, artCardOverImageLabelCls, artCardBorderSize, artCardMoreInfoCls } from "./Card.less";
var IS_TOUCH_DEVICE = isTouchDevice();
var STYLE_TO_SETTINGS = [
  // DispalyStyle 1
  {
    className: [artCardDisplayStyle1Cls, artCardBackgroundCls, artCardBorderCls],
    showFooter: true,
    showOverImageSection: false,
    showOverImageLabel: false,
    showOverlay: false,
    showPrice: true,
    showAuthor: true,
    showContent: true,
    showDetails: true,
    titleLevel: 5,
    authorLevel: 4,
    detailsLevel: 6,
    footerLevel: 5
  },
  // DispalyStyle 2
  {
    className: artCardDisplayStyle2Cls,
    showFooter: false,
    showOverImageSection: true,
    showOverImageLabel: false,
    showOverlay: false,
    showPrice: false,
    showAuthor: true,
    showContent: true,
    showDetails: true,
    titleLevel: 5,
    authorLevel: 4,
    detailsLevel: 6,
    footerLevel: 5
  },
  // DispalyStyle 3
  {
    className: [artCardDisplayStyle3Cls, artCardBackgroundCls, artCardBorderCls],
    showFooter: true,
    showOverImageSection: false,
    showOverImageLabel: false,
    showOverlay: false,
    showPrice: false,
    showAuthor: true,
    showContent: true,
    showDetails: false,
    titleLevel: 6,
    authorLevel: 5,
    detailsLevel: 6,
    footerLevel: 5
  },
  // DispalyStyle 4
  {
    className: artCardDisplayStyle4Cls,
    showFooter: false,
    showOverImageSection: true,
    showOverImageLabel: false,
    showOverlay: false,
    showPrice: false,
    showAuthor: true,
    showContent: true,
    showAction: true,
    showDetails: true,
    titleLevel: 6,
    authorLevel: 4,
    detailsLevel: 6,
    footerLevel: 5
  },
  // DispalyStyle 5
  {
    className: artCardDisplayStyle5Cls,
    showFooter: false,
    showOverImageSection: true,
    showOverImageLabel: true,
    showOverlay: false,
    showPrice: false,
    showAuthor: false,
    showContent: false,
    showDetails: false,
    titleLevel: 5,
    authorLevel: 4,
    detailsLevel: 6,
    footerLevel: 5
  },
  // DisplayStyle 6
  {
    className: [artCardDisplayStyle1Cls, artCardBackgroundCls, artCardBorderCls],
    showFooter: true,
    showOverImageSection: false,
    showOverImageLabel: false,
    showOverlay: false,
    showPrice: true,
    showPriceInFooter: true,
    showAuthor: false,
    showContent: true,
    showDetails: true,
    titleLevel: 5,
    authorLevel: 4,
    detailsLevel: 6,
    footerLevel: 5
  },
  // DispalyStyle 7
  {
    className: [artCardDisplayStyle1Cls, artCardBackgroundCls, artCardBorderCls],
    showFooter: false,
    showOverImageSection: true,
    showOverImageLabel: false,
    showOverlay: false,
    showPrice: true,
    showAuthor: true,
    showContent: true,
    showDetails: true,
    titleLevel: 5,
    authorLevel: 4,
    detailsLevel: 6,
    footerLevel: 5
  },
  // DispalyStyle 8
  {
    className: artCardDisplayStyle8Cls,
    showFooter: false,
    showOverImageSection: true,
    showOverImageLabel: false,
    showOverlay: false,
    showPriceInContent: true,
    showAuthor: true,
    showContent: true,
    showMoreInfo: true,
    showDetails: true,
    titleLevel: 6,
    authorLevel: 4,
    detailsLevel: 6,
    footerLevel: 5
  }
];
function getArtCardBorderSize() {
  return parseInt(artCardBorderSize, 10);
}
__name(getArtCardBorderSize, "getArtCardBorderSize");
var ArtCard = /* @__PURE__ */ function(_Component) {
  function ArtCard2(props) {
    var _this;
    _classCallCheck(this, ArtCard2);
    _this = _callSuper(this, ArtCard2, [props]);
    _this.state = {
      isOverlayVisible: false
    };
    _this.bindMethods();
    return _this;
  }
  __name(ArtCard2, "ArtCard");
  _inherits(ArtCard2, _Component);
  return _createClass(ArtCard2, [{
    key: "handleClick",
    value: /* @__PURE__ */ __name(function handleClick(e) {
      var _this$props = this.props, onArtworkClick = _this$props.onArtworkClick, restProps = _objectWithoutProperties(_this$props, _excluded);
      if (typeof onArtworkClick === "function") {
        onArtworkClick(e, restProps);
      }
    }, "handleClick")
    /**
     * toggleOverlay
     *
     * @param {Event} e
     */
  }, {
    key: "toggleOverlay",
    value: /* @__PURE__ */ __name(function toggleOverlay(e) {
      e.preventDefault();
      var isOverlayVisible = this.state.isOverlayVisible;
      this.setState({
        isOverlayVisible: !isOverlayVisible
      });
    }, "toggleOverlay")
    /**
     * bindMethods
     */
  }, {
    key: "bindMethods",
    value: /* @__PURE__ */ __name(function bindMethods() {
      this.toggleOverlay = this.toggleOverlay.bind(this);
      this.handleClick = this.handleClick.bind(this);
    }, "bindMethods")
    /**
     * render
     *
     * @returns {React.Element<*>}
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var _this$props2 = this.props, placeholder = _this$props2.placeholder, externalLink = _this$props2.externalLink, displayStyle = _this$props2.displayStyle, showFooter = _this$props2.showFooter, showOverImageSection = _this$props2.showOverImageSection, showOverImageLabel = _this$props2.showOverImageLabel, showAuthor = _this$props2.showAuthor, showPrice = _this$props2.showPrice, showPriceInContent = _this$props2.showPriceInContent, showOverlay = _this$props2.showOverlay, showAction = _this$props2.showAction, showDetails = _this$props2.showDetails, pictureProps = _this$props2.pictureProps, target = _this$props2.target, artworkUrl = _this$props2.artworkUrl, artworkTitle = _this$props2.artworkTitle, artistUrl = _this$props2.artistUrl, artistName = _this$props2.artistName, price = _this$props2.price, additionalContent = _this$props2.additionalContent, moreInfo = _this$props2.moreInfo, rentPrice = _this$props2.rentPrice, status = _this$props2.status, overlay = _this$props2.overlay, actionControls = _this$props2.actionControls, rightActionControls = _this$props2.rightActionControls, overImageLabel = _this$props2.overImageLabel, hoverContent = _this$props2.hoverContent, className = _this$props2.className, linkProps = _this$props2.linkProps, children = _this$props2.children, cardContentProps = _this$props2.cardContentProps, disableHeadingTags = _this$props2.disableHeadingTags;
      var isOverlayVisible = this.state.isOverlayVisible;
      var displayStyleIdx = parseInt(displayStyle, 10);
      var _ref = displayStyleIdx > 0 && displayStyleIdx <= STYLE_TO_SETTINGS.length && STYLE_TO_SETTINGS[displayStyleIdx - 1] || {}, classNameByType = _ref.className, settingsByType = _objectWithoutProperties(_ref, _excluded2);
      var showSettings = {
        showFooter,
        showOverImageSection,
        showOverImageLabel,
        showAuthor,
        showPrice,
        showPriceInContent,
        showOverlay,
        showAction,
        showDetails
      };
      var validShowSettings = Object.keys(showSettings).filter(function(i) {
        return typeof showSettings[i] === "boolean";
      }).reduce(function(result, i) {
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, i, showSettings[i]));
      }, {});
      var _ref2 = pictureProps || {}, pictureClassName = _ref2.className, restPictureProps = _objectWithoutProperties(_ref2, _excluded3);
      var urlRouteProps = externalLink || target ? _objectSpread(_objectSpread({
        href: artworkUrl
      }, target ? {
        target
      } : {}), {}, {
        external: true
      }) : {
        to: artworkUrl
      };
      var mergedSettings = _objectSpread(_objectSpread({}, settingsByType), validShowSettings);
      var PictureComponent = this.props.showImagePlaceholder ? PicturePlaceholder : Picture;
      var headingElm = mergedSettings.showContent ? /* @__PURE__ */ React.createElement(Heading, {
        placeholder,
        tag: disableHeadingTags ? "span" : "h4",
        level: mergedSettings.titleLevel,
        uppercase: false,
        className: artCardHeadingCls
      }, /* @__PURE__ */ React.createElement(Link, _extends({
        className: classNames(artCardLinkCls, artCardLinkArtworkCls),
        title: artworkTitle,
        onClick: this.handleClick
      }, urlRouteProps, linkProps), artworkTitle)) : null;
      return /* @__PURE__ */ React.createElement(Card, {
        className: classNames(artCardCls, classNameByType, _defineProperty({}, artCardTouchCls, IS_TOUCH_DEVICE), className),
        showBorder: false
      }, overlay && /* @__PURE__ */ React.createElement(CardOverlay, {
        isVisible: isOverlayVisible,
        onClose: this.toggleOverlay
      }, overlay), /* @__PURE__ */ React.createElement(CardMedia, {
        className: classNames(!!hoverContent && artCardMediaHoverCls)
      }, !placeholder ? /* @__PURE__ */ React.createElement(Link, _extends({
        className: artCardLinkCls,
        title: artworkTitle,
        onClick: this.handleClick
      }, urlRouteProps, linkProps), /* @__PURE__ */ React.createElement(PictureComponent, _extends({}, restPictureProps, {
        className: classNames(artCardPictureCls, pictureClassName)
      })), mergedSettings.showOverImageLabel && overImageLabel ? /* @__PURE__ */ React.createElement("div", {
        className: artCardOverImageLabelCls
      }, overImageLabel) : null, hoverContent ? /* @__PURE__ */ React.createElement("div", {
        className: artCardOverImageCls
      }, hoverContent) : null) : /* @__PURE__ */ React.createElement(BasePlaceholder, null), mergedSettings.showOverImageSection && actionControls ? /* @__PURE__ */ React.createElement("div", {
        className: classNames(artCardOverImageSectionCls, (!mergedSettings.showOverImageLabel || !overImageLabel) && artCardOverImageSectionRightCls)
      }, actionControls) : null), mergedSettings.showAction && children ? /* @__PURE__ */ React.createElement(CardContent, null, children) : null, mergedSettings.showContent && /* @__PURE__ */ React.createElement(CardContent, cardContentProps || null, mergedSettings.showMoreInfo && moreInfo ? /* @__PURE__ */ React.createElement("div", {
        className: artCardHeadingFlexCls
      }, headingElm, /* @__PURE__ */ React.createElement("div", {
        className: artCardMoreInfoCls
      }, moreInfo)) : headingElm, mergedSettings.showAuthor && /* @__PURE__ */ React.createElement("div", {
        className: classNames(artCardDetailCls, artCardLinkArtistCls)
      }, /* @__PURE__ */ React.createElement(Heading, {
        tag: disableHeadingTags ? "span" : "h5",
        level: mergedSettings.authorLevel,
        className: artCardHeadingCls,
        placeholder
      }, artistUrl ? /* @__PURE__ */ React.createElement(Link, {
        className: artCardLinkCls,
        to: artistUrl,
        title: artistName
      }, artistName) : artistName), mergedSettings.showPrice && (!placeholder ? /* @__PURE__ */ React.createElement("span", null, price) : /* @__PURE__ */ React.createElement(TextPlaceholder, null))), mergedSettings.showDetails ? /* @__PURE__ */ React.createElement("div", {
        className: artCardAdditionalContentCls
      }, !placeholder ? /* @__PURE__ */ React.createElement(React.Fragment, null, additionalContent && /* @__PURE__ */ React.createElement("span", null, additionalContent), mergedSettings.showPrice && /* @__PURE__ */ React.createElement("span", null, rentPrice)) : /* @__PURE__ */ React.createElement(TextPlaceholder, null)) : null, mergedSettings.showPriceInContent && (!placeholder ? /* @__PURE__ */ React.createElement("div", {
        className: artCardAdditionalContentCls
      }, /* @__PURE__ */ React.createElement("span", null, price)) : /* @__PURE__ */ React.createElement(TextPlaceholder, null)) || null), mergedSettings.showFooter && /* @__PURE__ */ React.createElement(CardFooter, {
        className: artCardFooterCls
      }, actionControls ? /* @__PURE__ */ React.createElement("div", {
        className: artCardFooterLeftCls
      }, !placeholder ? actionControls : /* @__PURE__ */ React.createElement(TextPlaceholder, null)) : null, status || overlay || rightActionControls || mergedSettings.showPrice && mergedSettings.showPriceInFooter ? /* @__PURE__ */ React.createElement("div", {
        className: artCardFooterRightCls
      }, status && (!mergedSettings.showPrice || !mergedSettings.showPriceInFooter || !price) ? /* @__PURE__ */ React.createElement("span", null, status) : null, mergedSettings.showPrice && mergedSettings.showPriceInFooter && price ? /* @__PURE__ */ React.createElement("span", null, price) : null, overlay ? /* @__PURE__ */ React.createElement(Button, {
        type: "ghost",
        size: "medium",
        icon: /* @__PURE__ */ React.createElement(CommentIcon, null),
        className: artCardOverlayBtnCls,
        onClick: this.toggleOverlay
      }) : null, rightActionControls) : null));
    }, "render")
  }]);
}(Component);
_defineProperty(ArtCard, "defaultProps", {
  displayStyle: 2,
  showFooter: null,
  showOverImageSection: null,
  showOverImageLabel: null,
  showOverlay: null,
  showPrice: null,
  showPriceInContent: null,
  showAuthor: null,
  showContent: null,
  showAction: null,
  showDetails: null,
  showMoreInfo: null,
  pictureProps: {
    img: {
      alt: ""
    }
  },
  externalLink: false,
  target: null,
  artworkUrl: null,
  artworkTitle: null,
  onArtworkClick: null,
  artistUrl: null,
  artistName: null,
  price: null,
  additionalContent: null,
  moreInfo: null,
  rentPrice: null,
  status: null,
  overlay: null,
  actionControls: null,
  rightActionControls: null,
  overImageLabel: null,
  showImagePlaceholder: false,
  hoverContent: null,
  className: null,
  linkProps: null,
  children: null,
  placeholder: false,
  cardContentProps: null,
  disableHeadingTags: false
});
export {
  ArtCard,
  getArtCardBorderSize
};
